import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';


import PhoneNumbers from './NumberCallerQueues';
import TimeQueues from './TimesQueues';


import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const QueueIdentifyOnHold = (props) => {
  const { queue, socketio } = props;

  const [ onHoldCalls, setOnHoldCalls ] = useState({});
  const [ countCalls, setCountCalls ] = useState(0);

  useEffect(() => {
    socketio.on(`${queue}`, async (data) => {      
      if (data.event === 'QueueCallerJoin') {
        setOnHoldCalls((prevState) => {
            prevState[`${data.uniqueid}`] = { clid: data.calleridnum, uniqueid: data.uniqueid };
            return prevState;
        });
        setCountCalls((prevState) => { 
          return prevState + 1;
        });
      };

      if(data.event == "QueueCallerAbandon") {
        setOnHoldCalls((prevState) => {
          delete prevState[data.uniqueid];
          return prevState;
        });
        setCountCalls((prevState) => { 
          return prevState - 1;
        });
      }

      if(data.event == "AgentConnect") {
        setOnHoldCalls((prevState) => {
          delete prevState[data.uniqueid];
          return prevState;
        });
        setCountCalls((prevState) => { 
          return prevState - 1;
        });
      }
    });
  }, [onHoldCalls, countCalls]);

  return (
    Object.keys(onHoldCalls).length > 0 ? Object.keys(onHoldCalls).map((uniq) => {
        return (     
          <tr className="is-size-7 has-text-centered" key={ uniq }>
            <PhoneNumbers numberPhone={ onHoldCalls[`${uniq}`].clid } />
            <TimeQueues timex={ 0 } />
          </tr>
        )
      }) : null
  )
}

// QueueIdentifyOnHold.propTypes = {
//   clid: PropTypes.string,
// };

export default QueueIdentifyOnHold;